import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { uploadFileFailed, uploadFileSuccessful } from '../actions';

export default function* uploadSignFile(action) {
  try {
    const formData = action.payload;
    const url = `${BACKEND_URL}/proxy/backend/api/v1/resources/documents/upload-signed-file`;
    const headers = {
      // Accept: 'multipart/form-data',
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };

    const dataResponse = yield makeRequest(url, formData, action, 'POST', true, headers, true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(uploadFileSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(uploadFileFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(uploadFileFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
